import { ObjectMapper } from "json-object-mapper";
import { IModel } from "services/models/IModel";
import { Model, OptionModel } from "services/models/model";

export interface ChartCountDetails {
	entityIds?: string[];
	id?: string;
	onLeave: number;
	inResignation: number;
	inTraining: number;
	inAptitude: number;
	inPlanning: number;
	allocated: number;
	inHiring: number;
	balance: number;
}

export interface WorkforcePlanReportDetailModel {
	company?: string;
	area?: string;
	costCenter?: string;
	workScaleGroup?: string;
	jobTitleGroup?: string;
	jobTitle?: string;
	companyId?: string;
	costCenterId?: string;
	workScaleGroupId?: string;
	jobTitleGroupId?: string;
	jobTitleId?: string;
	totalOnLeave?: number;
	totalInResignation?: number;
	totalInTraining?: number;
	totalInAptitude?: number;
	totalInPlanning?: number;
	totalAllocated?: number;
	totalInHiring?: number;
	totalApprenticesIdeal?: number;
	totalApprenticesReal?: number;
	totalApprentices?: number;
	totalTemporary?: number;
	isApprenticeGroup?: boolean;
	balance?: number;
	Company?: string;
	Area?: string;
	CostCenter?: string;
	WorkScaleGroup?: string;
	JobTitleGroup?: string;
	JobTitle?: string;
	CompanyId?: string;
	CostCenterId?: string;
	WorkScaleGroupId?: string;
	JobTitleGroupId?: string;
	JobTitleId?: string;
	TotalOnLeave?: number;
	TotalInResignation?: number;
	TotalInTraining?: number;
	TotalInAptitude?: number;
	TotalInPlanning?: number;
	TotalAllocated?: number;
	TotalInHiring?: number;
	TotalApprenticesIdeal?: number;
	TotalApprenticesReal?: number;
	TotalApprentices?: number;
	TotalTemporary?: number;
	IsApprenticeGroup?: boolean;
	Balance?: number;
}

export class WorkforcePlanReportItemModel extends Model {
	name: string = "";
	totalOnLeave: number = 0;
	totalInResignation: number = 0;
	totalInTraining: number = 0;
	totalInAptitude: number = 0;
	totalInPlanning: number = 0;
	totalAllocated: number = 0;
	totalInHiring: number = 0;
	balance: number = 0;
}

export class WorkforcePlanReportGroupModel extends WorkforcePlanReportItemModel {
	jobTitleGroups: WorkforcePlanReportItemModel[] = [];
}

export class WorkforcePlanReportCostCenterModel extends WorkforcePlanReportItemModel {
	workScaleGroups: WorkforcePlanReportGroupModel[] = [];
}

export class WorkforcePlanReportCompanyModel extends WorkforcePlanReportItemModel {
	costCenters: WorkforcePlanReportCostCenterModel[] = [];
}

export class ChartReportModel {
	chartName: string = '';
	filterBy: string = '';
	title: string = '';
	count: { [key: string]: ChartCountDetails };
	options: OptionModel[] = [];
	realized: number;
	totals: { category: string, planned: number, realized: number }[] = [];
}

export class WorkforcePlanOrganicEvolutionModel {
	months: string[] = [];
	ideal: number[] = [];
	real: number[] = [];

	static create(input: any): WorkforcePlanOrganicEvolutionModel {
		return ObjectMapper.deserialize<WorkforcePlanOrganicEvolutionModel>(WorkforcePlanOrganicEvolutionModel, input);
	}
}

export class WorkforcePlanReportModel implements IModel<WorkforcePlanReportModel> {
	report: WorkforcePlanReportCompanyModel[] = [];
	charts: ChartReportModel[] = [];
	details: WorkforcePlanReportDetailModel[] = [];
	organicEvolution: WorkforcePlanOrganicEvolutionModel = new WorkforcePlanOrganicEvolutionModel();

	static create(input: any): WorkforcePlanReportModel {
		const model = ObjectMapper.deserialize<WorkforcePlanReportModel>(WorkforcePlanReportModel, input);
		if (input?.charts) {
			model.charts = input.charts;
		}
		if (input?.details) {
			model.details = input.details;
		} else if (input?.Details) {
			model.details = input.Details;
		}
		return model;
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}
}
